
import { defineComponent } from 'vue'
import PlanDetailMixin from '~/mixins/planDetailMixin'

export default defineComponent({
  name: 'DowngradePlan',
  mixins: [PlanDetailMixin],
  data() {
    return {
      showConfirmDialog: false,
      updating: false,
      message:
        'Your team will lose access to Autofix, Code Formatters, and other automation features.'
    }
  },
  async fetch(): Promise<void> {
    await this.fetchContext()
  },
  methods: {
    async downgrade(close: () => void): Promise<void> {
      const dowgradeTo = this.availableDowngradePlans.planSlug
      this.updating = true
      try {
        await this.changeSubscriptionPlan({
          id: this.owner.id,
          planSlug: dowgradeTo
        })
        if (close) {
          close()
        } else {
          this.showConfirmDialog = false
        }
      } catch (e) {
        this.$toast.danger('Something went wrong while downgrading your plan')
      } finally {
        this.$emit('refetch')
        await this.refetchData()
        this.updating = false
      }
    },
    showDowngradePlanModal() {
      this.showConfirmDialog = true
    },
    close() {
      this.showConfirmDialog = false
    }
  }
})
